<template>
  <!-- <div v-show="env" :class="env==='wwjrxx'? 'login-warp': 'gd-login-warp'" >
    <div class="btns">
      <van-button type="info" :color="env==='wwjrxx'?'':'#b3312b'" class="info" @click="toLogin" round block
        >授权登录</van-button
      >
      <van-button type="default" round block @click="cancelLogin"
        >暂不登录</van-button
      >
    </div>
    <div class="mentions">
      <van-checkbox icon-size="16px" :checked-color="env==='wwjrxx'? '' :'#b3312b'" v-model="checked" shape="square" />
      <div style="margin-left: 10px">
        已阅读并同意<a @click="open(0)">《用户协议》</a>和<a @click="open(1)"
          >《隐私协议》</a
        >
      </div>
    </div> -->
  <!-- <van-dialog v-model="showAgreements" :title="title[titleIndex]" show-cancel-button>
      <iframe :src="url[titleIndex]" height="300px"/>
    </van-dialog> -->
  <!-- </div> -->
  <div>
    <div v-if="(resign && !wx)" class="reSignLogin">
      <p class="resign_name">{{ browerTitle }}登录</p>
      <van-form @submit="onSubmit">
        <van-field v-model="para.mobile" name="手机号" label="手机号" placeholder="手机号" label-class="resign_key" maxlength="11"
          clearable class="inputBoder" :rules="[{ required: true, message: '请填写手机号' }]" />
        <van-field v-model="para.smsCode" center clearable label="短信验证码" class="inputBoder" label-class="resign_key"
          placeholder="请输入短信验证码">
          <template #button>
            <van-count-down v-if="status == 2" :time="time" @finish="finish">
              <template #default="timeData">
                <span class="seconds">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
            <label v-else class="sendCode" @click="handleCode">{{ sendCode }}</label>

          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">登录</van-button>
        </div>
      </van-form>

    </div>


    <div v-else>
      <div v-show="env" class="app-login-warp">
        <div class="top_img">
          <img src="../../assets/images/login/app_login_top.png" alt="">
        </div>
        <div class="logo">
          <div class="logo_icon">
            <img src="../../assets/images/logo3.png" alt="" class="logo_img">
            <!-- <img src="../../assets/images/login/logo.png" alt="" class="logo_img">
        <img src="../../assets/images/login/logo_txt.png" alt="" class="logo_text"> -->
            <div class="logo_text">无为股道</div>
          </div>
        </div>
        <div class="btns">
          <!-- <p class="resign_name" v-if="resign" >重签协议登录</p> -->

          <van-button type="info" class="info" @click="toLogin" round block>授权登录</van-button>
          <van-button type="default" round block @click="cancelLogin">暂不登录</van-button>
        </div>
        <div class="mentions">
          <van-checkbox icon-size="16px" :checked-color="env === 'wwjrxx' ? '' : '#b3312b'" v-model="checked"
            shape="square" />
          <div style="margin-left: 10px">
            已阅读并同意<a @click="open(0)">《用户协议》</a>和<a @click="open(1)">《隐私协议》</a>
          </div>
        </div>
        <!-- <van-dialog v-model="showAgreements" :title="title[titleIndex]" show-cancel-button>
      <iframe :src="url[titleIndex]" height="300px"/>
    </van-dialog> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage, isWeixin, removeStorage, setStorage } from "../../utils/common";
import { piciLogin, weixinLogin } from "../../utils/routerFun";
import { Dialog } from "vant";
import * as api from '../../service/user'

export default {
  data() {
    return {
      checked: false,
      showAgreements: false,
      title: ['用户协议', '用户隐私'],
      url: ['https://dstatic.wwjrxx.com/image/agreement.html', 'https://dstatic.wwjrxx.com/image/privacy.html'],
      url2: ['https://cloud.wwgd888.com/commonjs/user-agreement-pg', 'https://cloud.wwgd888.com/commonjs/secret-agreement-pg'],
      // titleIndex: 0,
      env: getStorage('env'),
      resign: false,
      wx: isWeixin(),
      time: 60000,
      sendCode: '发送验证码',
      status: 1,
      para: {
        mobile: null,
        smsCode: null,
      },
      query: null,
      browerTitle: ''
    };
  },
  created() {
    const { path, query } = this.$route
    this.query = query
    this.wx = isWeixin()
    const brower = [
      {
        title: '重签协议',
        url: 'reSign',
      },
      {
        title: '退款协议',
        url: 'serviceTermination',
      },
    ]
    if(!this.wx) { //  非微信环境下
      const res = brower.filter(e => query.url?.includes(e.url)) //  判断是否存在需要打开
      if(res.length > 0) {
        this.browerTitle = res[0].title
        this.resign = true
      }
    } else {
      this.resign = false
    }
  

    if(query.url?.includes('serviceTermination')) {
      localStorage.setItem('serviceTermination', query.url)
    } else {
      removeStorage('serviceTermination')
    }
  },
  async mounted() {
    if (!getStorage('env')) { // 直接清楚缓存env 刷洗会白屏 
      setTimeout(() => {
        this.env = getStorage('env')
      }, 1000);
    }
  },
  methods: {
    handleCode() { // 发送验证码
      // 执行成功之后...
      if (this.para.mobile.length == 11) {
        api.smsSend({ mobile: this.para.mobile }).then(res => {
          console.log(res)
          this.$toast.success('验证码已发送')
        })
        this.status = 2
      } else {
        this.$toast.fail('请输入正确的手机号')
      }
    },
    finish() { //  倒计时结束
      this.sendCode = '重新发送'
      this.status = 3
    },
    onSubmit() {
      if (this.para.smsCode.length != 6) {
        this.$toast.fail('请输入正确的验证码')
      } else {
        api.phoneLogin({
          ...this.para
        }).then(res => {
          if (res) {
            setStorage('liveuser', res)
            removeStorage('cancelLogin')
            //  判断跳转退款协议是否携带token
            if(location.href.includes('serviceTermination') && !location.href.includes('token')) {
              //  没有token则补充token至url
              location.replace(decodeURIComponent(location.search.slice(5)) + '&token=' + JSON.parse(localStorage.getItem('liveuser'))?.token?.split(" ")[1])
            } else {
              location.replace(decodeURIComponent(location.search.slice(5)))
            }
          } else {
            this.$toast.fail('系统错误')
          }
        })
      }
    },
    toLogin() {
      if (!this.checked) {
        Dialog.alert({
          title: "提示",
          message: "请勾选已阅读《用户协议》和《隐私协议》",
        }).then((e) => {
          // on close
          if (e === "confirm") {
            this.checked = true;
          }
        });
        return;
      }
      const { query } = this.$route
      console.log('this.$route---', this.$route);
      let hostUrl = ''
      if (query.url) {
        if (query.url.includes('/reSign')) {
          hostUrl = this.paramsToUrl(query).replace('url=', '')
        } else if(getStorage('serviceTermination'))  {
          hostUrl = location.origin + '/user'
        } else {
          hostUrl = query.url
        }
      } else {
        hostUrl += "https://" + location.host;
        hostUrl += query.pathName ? query.pathName : '/user'
      }
      removeStorage('cancelLogin')
      console.log('hostUrl', hostUrl);
      if (isWeixin()) {
        weixinLogin(hostUrl, this);
      } else {
        piciLogin(hostUrl, this)
      }

    },
    cancelLogin() {
      setStorage('cancelLogin', 1)
      const { query } = this.$route
      const { url } = query
      console.log('cancelLoginthis.$route', this.$route);
      // this.$router.replace(url)
      location.href = url
    },
    open(index) {
      this.titleIndex = index;
      // this.showAgreements = true;
      let urlString = this.env === 'wwjrxx' ? this.url[index] : this.url2[index]
      this.$router.push({
        path: '/webview',
        query: {
          url: urlString
        }
      })
    },
    paramsToUrl(params) {
      return Object.keys(params)
        .sort((a, b) => (a === 'url' ? -1 : b === 'url' ? 1 : 0))
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    }
  },
};
</script>

<style>
.resign_key {
  flex: none !important;
  width: 80px;
}
</style>
<style lang="less" scoped>
.inputBoder {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 10px;
}

.reSignLogin {
  width: 80%;
  margin: 10px auto;
}

.sendCode {
  color: #1989fa;
}

.seconds {
  color: #EC2505;
}

.resign_name {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 200px;
  margin-bottom: 20px;
}

.gd-login-warp {
  height: 100vh;
  background-image: url("https://dstatic.wwjrxx.com/image/static/wwgd_bg_1.jpg");
  background-size: 100% 100%;

  .btns {
    width: 60%;
    max-width: 500px;
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
  }

  .info {
    margin-bottom: 15px;
  }

  .mentions {
    font-size: 11px;
    position: absolute;
    bottom: 50px;
    left: 50%;
    width: 266px;
    transform: translate(-45%, -50%);
    display: flex;
    line-height: initial;

    a {
      color: #b3312b;
    }
  }
}

.login-warp {
  height: 100vh;
  background-image: url("../../assets/user/loginBg.png");
  background-size: 100% 100%;

  .btns {
    width: 60%;
    max-width: 500px;
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
  }

  .info {
    margin-bottom: 15px;
  }

  .mentions {
    font-size: 11px;
    position: absolute;
    bottom: 50px;
    left: 50%;
    width: 266px;
    transform: translate(-45%, -50%);
    display: flex;
    line-height: initial;

    a {
      color: #1989fa;
    }
  }
}

.app-login-warp {
  height: 100vh;
  background-color: #F5F5F5;
  position: relative;

  .top_img {
    width: 100%;
    height: 300px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .logo {
    position: absolute;
    left: 50%;
    top: 40%;
    z-index: 10;
    transform: translate(-50%, -50%);
  }

  .logo_icon {
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo_img {
      width: 80px;
      // height: 100px;
      // margin-bottom: 10px;
    }

    .logo_text {
      font-size: 17px;
      font-weight: 600;
      margin-top: 6px;
      color: #252424;
    }
  }

  .btns {
    width: 60%;
    max-width: 500px;
    position: absolute;
    bottom: 20%;
    left: 50%;
    transform: translateX(-50%);
    color: #333;
    z-index: 999;

    .info {
      margin-bottom: 15px;
      border: 1px solid #EC2505;
      background: #EC2505;
    }
  }

  .mentions {
    font-size: 11px;
    position: absolute;
    top: 84%;
    left: 50%;
    width: 266px;
    transform: translate(-45%, -50%);
    display: flex;
    line-height: initial;

    a {
      color: #76B1F0;
    }
  }
}
</style>